import { ChangeDetectionStrategy, Component, inject, input, Input, OnChanges, OnDestroy, output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { Role } from '../../enums/role';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-role-select',
  imports: [
    FormsModule,
    SelectModule,
    CheckboxModule
  ],
  templateUrl: './role-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class RoleSelectComponent implements OnChanges, OnDestroy {
  private translate = inject(TranslateService); // Iniezione moderna di Angular
  private langSubscription!: Subscription;

  items = input<Role[]>([]);

  itemsChange = output<Role[]>();

  options: any[] = []
  selectedItems: any[] = [];

  constructor() {
    // Generiamo la lista base completa dall'enum all'avvio
    this.options = Object.keys(Role)
      .filter(key => isNaN(Number(key)))
      .map(key => ({
        id: Role[key as keyof typeof Role],
        translationKey: key, // Genera chiavi dinamiche come 'ROLES.Admin'
        label: '',                      // Verrà riempito subito dopo
        isSelected: false
      }));

    // 2. Traduciamo le voci all'avvio e ad ogni cambio lingua successivo
    this.options.forEach(o => {
      o.label = this.translate.instant(o.translationKey);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // Quando l'input cambia (anche in un secondo momento asincrono), aggiorniamo lo stato
    if (changes['items']) {
      const activeIds = this.items() || [];

      // Aggiorna il flag isSelected sull'elenco completo
      this.options.forEach(r => {
        r.isSelected = activeIds.includes(r.id);
      });

      // Sincronizza il modello interno di PrimeNG con i riferimenti corretti
      this.selectedItems = this.options.filter(r => r.isSelected);
    }
  }

  ngOnDestroy() {
    // Evita memory leak distruggendo la sottoscrizione al cambio lingua
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

  // Helper per accendere la checkbox nel template custom di PrimeNG
  isItemSelected(option: any): boolean {
    return this.selectedItems.some(s => s.id === option.id);
  }

    // Helper per mostrare il testo cumulativo nel p-select chiuso
  getLabel(): string {
    if (!this.selectedItems || this.selectedItems.length === 0) {
      return '';
    }

    // Estrae la proprietà 'label' da ogni oggetto selezionato e le unisce con ", "
    return this.selectedItems.map(opt => opt.label).join(', ');
  }

    // 3. Esegue lo scatto e l'emissione ad ogni click dell'utente
    onSelectionChange() {
      // Sincronizza i booleani isSelected nell'array master
      this.options.forEach(o => {
        o.isSelected = this.selectedItems.some(s => s.id === o.id);
      });

      // Estrae solo gli ID numerici (Role[]) correnti e li emette al padre
      const updatedRoles: Role[] = this.selectedItems.map(s => s.id);
      this.itemsChange.emit(updatedRoles);
    }
}
